<template>
  <div class="card-body">
    <button class="btn btn-primary" @click="getData(), (modal = true)">
      <template v-if="table_selected.id">
        {{ table_selected.name }}
      </template>
      <template v-else>
        {{ $t("Select Table") }}
      </template>
    </button>

    <div
      v-if="modal"
      class="modal shadow-lg fade show"
      tabindex="-1"
      role="dialog"
      style="display: block"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <p class=" ">
              <img src="@/assets/red.svg" width="20" alt="" />
              {{ $t("busy") }}
              <img src="@/assets/w.svg" width="20" alt="" />
              {{ $t("available") }}
            </p>
            <div class="clear-fix"></div>
            <button
              type="button"
              class="btn btn-table"
              v-for="table in tables"
              :key="table.id"
              :disabled="table.status === 'busy'"
              :class="{
                busy: table.status === 'busy',
                'btn-primary': table.id === table_selected.id,
              }"
              @click="table_selected = table"
            >
              {{ table.name }}
            </button>
            <div class="clear-fix"></div>

            <button @click="modal = false" class="btn btn-close float-right">
              {{ $t("Close") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="css">
.btn-table {
  padding: 20px !important;
  margin-right: 5px;
  margin-top: 5px;
  border: 1px solid !important;
}
.selected_table {
  background: blue !important;
}
.busy {
  background: #f61818 !important;
  border: 0px !important;
  color: white !important;
}
.modal-dialog {
  max-width: 100%;
}
</style>

<script>
import store from "@/store";
export default {
  name: "BaseWalkin",
  data() {
    return {
      modal: false,
      parentLocation: [],
      meta_location: {},
      table_selected: {},
      error: false,
    };
  },
  watch: {
    table_selected: {
      handler(value) {
        this.submitData();
      },
      deep: true,
    },
  },
  computed: {
    tables() {
      return store.getters["location/locations"];
    },
    loading() {
      return store.getters["location/loading"];
    },
    order() {
      return store.getters["order/pending_order"];
    },
    hotel() {
      return store.getters["location_selected/placeSelected"] || {};
    },
    orderInfo() {
      return store.getters["order/order_info"];
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.table_selected = this.orderInfo.table || {};
      let data = {
        type_id: this.hotel.id,
        type: "TABLE",
      };
      await store.dispatch("location/getLocations", data);
    },
    async submitData() {
      let data = {
        location_id: this.table_selected.id,
        table: this.table_selected,
      };
      this.$store.dispatch("order/setOrderInfo", data);
      if (this.table_selected.id) {
        this.$emit("valid", true);
      } else {
        this.$emit("valid", false);
      }
    },

    // async submit() {
    //   if (this.table_selected.id) {
    //     await store.dispatch("order/submitPendingOrder", this.table_selected);
    //     if (this.state_order) {
    //       this.$store.dispatch("order/clearOrder");
    //       this.$router.push({ name: "ordercompleted" });
    //     }
    //   }
    // },
  },
};
</script> 